var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-select-multi-value');
import { breakpoints, theme } from '@shapeable/theme';
import { EntityValue } from './entity-value';
import { components as Components } from 'react-select';
import { Content } from '../elements/content';
export var EntitySelectMultiValueDefaultProps = {
  showDescription: false
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    padding: ", " ", " ", " ", ";\n    flex-direction: column;\n  "], ["\n    display: flex;\n    padding: ", " ", " ", " ", ";\n    flex-direction: column;\n  "])), theme.UNIT(1), theme.UNIT(4), theme.UNIT(1), theme.UNIT(1, -1))
});
var ValueStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-wrap: nowrap;\n    flex-shrink: 0;\n\n    ", "\n  "], ["\n    flex-wrap: nowrap;\n    flex-shrink: 0;\n\n    ", "\n  "])), function (_a) {
    var hasIndent = _a.hasIndent;
    return hasIndent && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), theme.UNIT(3));
  })
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", ";\n    padding-top: ", ";\n  "], ["\n    color: ", ";\n    font-size: ", ";\n    padding-top: ", ";\n  "])), theme.COLOR('text'), theme.FONT_SIZE(13), theme.UNIT(3))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Value: styled(EntityValue)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Description: styled(Content)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
export var EntitySelectMultiValue = function EntitySelectMultiValue(props) {
  var className = props.className,
      data = props.data,
      imageStyle = props.imageStyle;
  var entity = data.entity;
  var hasIndent = imageStyle === 'banner'; // const { select } = defn;
  // const badge = select.optionBadge(data);

  return (
    /* @ts-ignore */
    React.createElement(Components.MultiValue, __assign({}, props), React.createElement(My.Container, {
      className: cls.name(className)
    }, React.createElement(My.Value, {
      hasIndent: hasIndent,
      variant: "small",
      entity: entity
    })))
  );
};
export var EntitySelectMultiValueWithDescriptions = function EntitySelectMultiValueWithDescriptions(props) {
  return React.createElement(EntitySelectMultiValue, __assign({}, props, {
    showDescription: true
  }));
};
EntitySelectMultiValue.defaultProps = EntitySelectMultiValueDefaultProps;
EntitySelectMultiValue.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;